import React, { useState } from 'react';
import { Button, Message, Modal, Progress, Table, Uploader, useToaster } from 'rsuite';
import api from '../../config/api';

const { Column, HeaderCell, Cell } = Table;

const ModalUsersMass = ({ open, setOpen }) => {
  const [file, setFile] = useState(null);
  const [progress, setProgress] = useState(0);
  const [uploading, setUploading] = useState(false);
  const [errors, setErrors] = useState([]);
  const toaster = useToaster();

  const handleUpload = async () => {
    if (!file) return;

    const formData = new FormData();
    formData.append('file', file);

    try {
      setUploading(true);
      const response = await api.post(
        `${process.env.REACT_APP_API_URL}User/upload-users`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          },
          onUploadProgress: e => {
            const percent = Math.round((e.loaded * 100) / e.total);
            setProgress(percent);
          }
        }
      );
      const uploadResult = response.data.data;

      console.log('response', response);
      if (uploadResult?.errors?.length > 0) {
        setErrors(uploadResult?.errors);
      }

      if (uploadResult?.successCount == 0 && uploadResult?.errorCount > 0) {
        toaster.push(
          <Message showIcon type="error">
            Import failed!
          </Message>,
          { placement: 'topCenter' }
        );
      } else {
        toaster.push(
          <Message showIcon type="success">
            Import completed!
          </Message>,
          { placement: 'topEnd' }
        );

        setOpen(false);
        setFile(null);
        setProgress(0);
      }
    } catch (err) {
      console.error(err);
      toaster.push(
        <Message showIcon type="error">
          Import failed!
        </Message>,
        { placement: 'topEnd' }
      );
    } finally {
      setUploading(false);
    }
  };
  return (
    <div>
      <Modal open={open} onClose={() => setOpen(false)}>
        <Modal.Header>
          <Modal.Title>Import Excel File</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Uploader
            autoUpload={false}
            // fileList={file ? [file] : []}
            onChange={files => {
              setFile(files[0]?.blobFile || null);
              setErrors([]);
            }}
            draggable
            accept=".xlsx,.xls"
            multiple={false}
            onRemove={() => setErrors([])}
            onReupload={() => setErrors([])}
          >
            <div style={{ padding: 20, textAlign: 'center' }}>Click or drag file to this area</div>
          </Uploader>

          {uploading && (
            <Progress.Line
              percent={progress}
              showInfo
              strokeColor="var(--rs-primary-500)"
              style={{ marginTop: 20 }}
            />
          )}

          {errors?.length > 0 && (
            // <div className="error-list">
            //   <h4>❌ Import Errors</h4>
            //   <ul>
            //     {errors?.map((err, idx) => (
            //       <li key={idx}>
            //         <strong>Row {err.row}</strong> – <em>{err.user}</em>: {err.error}
            //       </li>
            //     ))}
            //   </ul>
            // </div>
            <Table
              data={errors || []}
              height={200}
              bordered
              cellBordered
              autoHeight
              style={{ marginTop: 20 }}
              wordWrap="break-word"
            >
              <Column flexGrow={1}>
                <HeaderCell>User</HeaderCell>
                <Cell dataKey="Email" style={{ whiteSpace: 'pre-line' }} />
              </Column>

              <Column flexGrow={3}>
                <HeaderCell>Error</HeaderCell>
                <Cell dataKey="error" style={{ whiteSpace: 'pre-line' }} />
              </Column>
            </Table>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={handleUpload} appearance="primary" disabled={!file || uploading}>
            Start Import
          </Button>
          <Button onClick={() => setOpen(false)} appearance="subtle">
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ModalUsersMass;
